import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {
    b64toBlob,
    create_UUID,
    filterTransactionTypes,
    getLabelByValue,
    RightExists,
    showAxiosError
} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import IncomeForm from "./IncomeForm";
import moment from "moment";
import FileSaver from "file-saver";
import LoadingIndicator from "../../common/LoadingIndicator";
import * as headerContent from "../../constants/exportcontent";
import Alert from "react-s-alert";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";
import IncomeDeleteModal from "./IncomeDeleteModal";

class IncomeList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            add: false,
            selectedIncome: null,
            branches: null,
            incomes: [],
            totalIdList: [],
            incomeTypes: [],
            transactionChannels: [],
            transactionTypes: [],
            cities: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addIncomeModal: false,
            addDeleteModal:false,
            isLoading: false,
        };

        this.listIncomes = this.listIncomes.bind(this);
        this.cancelIncomeCreation = this.cancelIncomeCreation.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listIncomeTypes = this.listIncomeTypes.bind(this);
        this.listTransactionChannels = this.listTransactionChannels.bind(this);


    }

    componentDidMount() {
        this.listIncomeTypes();
        this.listTransactionChannels();
    }

    listIncomeTypes() {
        let self = this;
        let params = {
            //url: API_BASE_URL+"/transaction-type/expenses" ,
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    addNew() {
        let self = this;
        self.setState({
            selectedIncome: null,
            addIncomeModal: true,
            add:true,
        })
    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.incomeContent;
        dataSet.sheetName = 'Gelir İşlemleri Listesi';
        dataSet.uuid = create_UUID();
        dataSet.idList = this.state.totalIdList;
        return dataSet;
    }

    async exportXls() {
        let self = this;
        let data = self.arrangeDataSet();
        let params = {
            url: API_BASE_URL + '/financial-transaction/downloadReportIncomes',
            method: "post",
            data: data,
        };
        Alert.success(
            "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
            " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
        await request(params).then(() => {
            self.props.triggerDownloadRequestTooltip();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listIncomes(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/financial-transaction/fetchIncomes?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let incomes = (response.data && response.data.page) ? response.data.page.content : [];
                let totalIdList = response.data ? response.data.selectedIdList : [];
                let totalChanged = false;
                if (response.data.page.totalElements !== self.state.total) {
                    totalChanged = true;
                }
                self.setState({
                    page: !totalChanged ? page : 0,
                    size: size,
                    total: response.data.page.totalElements,
                    incomes,
                    totalIdList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelIncomeCreation() {
        this.setState({
            addIncomeModal: false,
            selectedIncome: null,
            addDeleteModal:false,
        });
        this.listIncomes(this.state.accessor, this.state.direction, this.state.page, this.state.size);
    }

    handleEdit(item) {
        let self = this;
        let data = item.id;
        let params = {
            url: API_BASE_URL + "/financial-transaction/" + item.id,
            data: data,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                mode: 'edit',
                selectedIncome: response.data,
                addIncomeModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleExportReceipt(item) {
        let params = {
            url: API_BASE_URL + "/receipt/create-form/" + item.receipt.id,
            method: 'get'
        };
        request(params).then(function (response) {
            const data = response.data.substring(response.data.indexOf(',') + 1);
            var blob = b64toBlob(data, 'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, item.receipt.receiptNo + "_" + item.branchId + "_Makbuz.pdf");
        }).catch(function (error) {
            showAxiosError(error);
        });

    }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listIncomes(this.state.accessor, this.state.direction, page, this.state.size))
    }

    add(x, y) {

        let numx = x ? (isNaN(x) ? 0 : x) : 0;
        let numy = y ? (isNaN(y) ? 0 : y) : 0;

        return (parseFloat(numx) + parseFloat(numy)).toFixed(2);
    }

    compareSums(transactionItemList, accrualList) {
        let sumTransactionItems = 0;
        let sumAccrualItems = 0;
        console.log("transactionItemList, accrualList", transactionItemList, accrualList);
        sumTransactionItems = transactionItemList.filter(i => [1, 2].includes(i.transactionTypeId)).length > 0
            ?
            transactionItemList.filter(i => [1, 2].includes(i.transactionTypeId)).map(i => i.amount).reduce(this.add)
            :
            sumTransactionItems;

        sumAccrualItems = accrualList.length > 0 ? accrualList.map(i => i.amount).reduce(this.add) : sumAccrualItems;

        console.log("sumTransactionItems,sumAccrualItems", sumTransactionItems, sumAccrualItems);

        return parseFloat(sumTransactionItems).toFixed(2) !== parseFloat(sumAccrualItems).toFixed(2)

    }

    handleDelete(item) {
        this.setState({
            selectedIncome: item,
            addDeleteModal: true
        })
    }

    render() {

        let incomeTypeSelectdata;
        let transactionChannelSelectdata;
        let transactionTypes;
        let transactionChannels;
        let branchSelectdata;
        let citySelectdata;
        const {incomes} = this.state;
        console.log(this.state.incomes)
        const {branches} = this.props;
        const {cities} = this.props;
        const header = [{value: null, label: "Tümü"}];
        const branchHeader = [{value: null, label: "Tümü"}, {value: "0", label: "BİRLİK MERKEZİ"},];
        const isCancelledSelectData = [{value: null, label: "Tümü"}, {
            value: "true",
            label: "İptal Edildi"
        }, {value: "false", label: "Aktif"}];
        const isTransferredSelectData = [{value: null, label: "Tümü"}, {
            value: "true",
            label: "Transfer Edildi"
        }, {value: "false", label: "Transfer Edilmedi"}];

        transactionTypes = this.state.transactionTypes;
        transactionChannels = this.state.transactionChannels;
        let incomeTypes = transactionTypes ? filterTransactionTypes(transactionTypes, "INCOME") : [];
        incomeTypes ? incomeTypeSelectdata = header.concat(incomeTypes) : incomeTypeSelectdata = header;
        transactionChannels ? transactionChannelSelectdata = header.concat(transactionChannels) : transactionChannelSelectdata = header;
        branches ? branchSelectdata = branchHeader.concat(branches) : branchSelectdata = branchHeader;
        cities ? citySelectdata = header.concat(cities) : citySelectdata = header;


        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedItem)}>
                    Gelir Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete(this.state.selectedItem)}>
                    Gelir Silme
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Kişi/Şirket Adı",
                accessor: "transactionTitle",
                Cell: (item) => {
                    return <label>
                        {item.transactionTitle}
                        {!item.isCancelled && item.accrualList && Array.isArray(item.accrualList) && item.transactionItemList && Array.isArray(item.transactionItemList) &&
                        this.compareSums(item.transactionItemList, item.accrualList) &&
                        <i style={{color: 'orange'}} rel="tooltip"
                           title="Tahsil Edilen Aidat Miktarı Seçilen Aidat Borcu Miktarına Eşit Değil. Bilgileri Düzeltiniz!"
                           className="fa fa-exclamation-circle" aria-hidden="true"/>
                        }
                    </label>
                }
            },
            {
                Header: "Gelir Durumu ",
                accessor: "isCanceled",
                Cell: (item) => {
                    if (item.isCancelled)
                        return <label style={{color: 'red'}}>İptal Edildi</label>;
                    else if (item.isTransferred)
                        return <label style={{color: 'red'}}>Transfer Edildi</label>;
                    else
                        return <label>Aktif</label>;
                },
            },
            {
                Header: "İşlem Tarihi",
                accessor: "transactionDate",
                Cell: item => (
                    <label>{moment.utc(item.transactionDate).format("DD.MM.YYYY")}</label>)

            },
            {
                Header: "Tutar",
                accessor: "amount",
                Cell: item => (
                    <label>{item.amount && item.amount.toString().replace('.', ',') + ' ₺'}</label>)
            },

        ];

        if (this.props.currentUser.realm.toString() === "0") {
            columns.push({
                Header: "Oda",
                accessor: "branchId",
                Cell: item => (
                    <label>{branchSelectdata && getLabelByValue(branchSelectdata, item.branchId).toString().substring(0, 15) + ".."}</label>
                )
            });
        }


        columns.push({
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            Cell: item => (
                <div>
                    <Dropdown overlay={menu} trigger='click' onClick={() => this.setState({selectedItem: item})}>
                        <Button style={{ background: '#3b6b96', height: '30px', width: '100px', color: 'white', borderRadius: '0.375em', fontSize: "12px"}}>
                            Seçiniz<Icon type="down"/>
                        </Button>
                    </Dropdown>
                    {(item.receipt) &&
                        <button type="button" onClick={() => this.handleExportReceipt(item)} data-toggle="tooltip" data-placement="bottom" title="Makbuz İndir" style={{ background: 'linear-gradient( rgb(241, 241, 37), rgb(220, 214, 8))', rel: "tooltip" }} className="Btn btn-sm btn-icon">
                            <i className="fas fa-download"/>
                        </button>
                    }
                </div>
            )
        });


        const fields = [
            {
                accessor: "transactionTitle",
                label: "Kişi/Şirket Adı",
                type: "text",
                operator: "=",
            },
            {
                label: "Gelir Tipi",
                accessor: "transactionTypeId",
                type: "select",
                operator: "=",
                selectData: incomeTypeSelectdata,
            },
            {
                label: "İşlem Tarihi(..'den Sonra)",
                accessor: "min_transactionDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "İşlem Tarihi(..'den Önce)",
                accessor: "max_transactionDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
            {
                label: "İşlem Kanalı",
                accessor: "transactionChannelId",
                type: "select",
                operator: "=",
                selectData: transactionChannelSelectdata,
            },
            {
                label: "Gelir Durumu",
                accessor: "isCancelled",
                type: "select",
                operator: "=",
                selectData: isCancelledSelectData,
            },
            {
                label: "Transfer Durumu",
                accessor: "isTransferred",
                type: "select",
                operator: "=",
                selectData: isTransferredSelectData,
            },
        ];
        if (this.props.currentUser.realm.toString() === "0") {
            fields.push({
                label: "Oda",
                accessor: "branchId",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },);
        }

        fields.push({
            label: "İl",
            accessor: "member.city.id",
            type: "select",
            operator: "=",
            selectData: citySelectdata,
        },);

        return (
            <div className="financial-transaction-list-container">
                <div className="row baseBackground">
                    {
                        (this.state.isLoading) &&
                        <div className="loader">
                            <LoadingIndicator/>
                        </div>
                    }
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Oda Gelir Listesi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={incomes}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listIncomes}
                                style={{width:"100%"}}
                            />
                        </div>
                    </div>
                    {
                        (RightExists("ROLE_RIGHT_PAYMENT_CREATE", this.props.authorities))
                        &&
                        <div className="new-button-holder">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Yeni Gelir Ekle"
                                    style={{
                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                        height: '40px',
                                        width: '160px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                        marginBottom:"5px",
                                    }}
                                    rel="tooltip" className="TekBtn add-new-financial "

                                    onClick={() => this.addNew()}>
                                YENİ GELİR EKLE
                            </button>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Excel İndir"
                                    style={{
                                        background: 'linear-gradient(#129a30, #116128)',
                                        height: '40px',
                                        width: '160px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                    }}
                                    rel="tooltip" className="TekBtn excel "

                                    onClick={() => this.exportXls()}>
                                GELİR EXCEL İNDİR
                            </button>
                        </div>
                    }

                    <Modal isOpen={this.state.addIncomeModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelIncomeCreation}>Gelir Düzenle</ModalHeader>
                        <ModalBody>
                            <IncomeForm cancelProcess={this.cancelIncomeCreation}
                                        selectedIncome={this.state.selectedIncome}
                                        mode={this.state.mode}
                                        currentUser={this.props.currentUser}
                                        handleSearch={this.handleSearch}
                                        transactionTypes={this.state.transactionTypes}
                                        transactionChannels={this.state.transactionChannels}
                                        allBranches={this.props.allBranches}
                                        channel="income"
                            />
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelIncomeCreation}>
                            Gelir Silme
                        </ModalHeader>
                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                            <IncomeDeleteModal
                                cancelProcess={this.cancelIncomeCreation}
                                selectedIncome={this.state.selectedIncome}
                                handleLogout={this.handleLogout}/>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default IncomeList;



// WEBPACK FOOTER //
// ./src/page/financial/IncomeList.js